import React from 'react'
import { Svg, ga } from '../../application'
import { withRouter } from 'react-router-dom'
import styled from 'react-emotion'

const LinkWithIcon = styled('a')`
  display: inline-flex;      
  align-items: center;
  flex-direction: ${props => props.iconRight ? 'row-reverse' : 'row'};
  font-weight: bold;
  cursor: pointer;
  svg.pictogram {
    margin: ${props => props.iconRight ? '0 0 0 5px' : '0 5px 0 0'};
  }
`

export default withRouter(({ icon, action, href, to, text, tracking, iconRight, history, className = '' }) => {
  const events = {
    onClick: () => {
      if (tracking)
        ga.buttonClick(tracking)
      if (action)
        action()
      if (to) {
        history.push(to)
        window.scrollTo(0, 0)
      }
    }
  }
  const props = href
    ? { ...events, href, target: '_blank' }
    : events

  return (
    <LinkWithIcon {...{ ...props, iconRight, className: to === window.location.pathname ? `active ${className}` : className }}>
      {icon && <Svg icon={icon} />}
      {text}
    </LinkWithIcon>
  )
})
